function Footer() {
  return (
    <a
      href='https://www.flaticon.com/free-icons/art'
      className='custom-muted'
      title='art icons'
    >
      Art icons created by Freepik - Flaticon
    </a>
  );
}

export default Footer;
